// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"style_testimonials__4IQMv"};